<template>
    <vue-tel-input
        ref="telInput"
        :key="activeDefaultCountry"
        v-model="localValue"
        @validate="onValidate"
        @country-changed="onCountryChanged"
        :autoDefaultCountry="false"
        :mode="'international'"
        :defaultCountry="activeDefaultCountry"
        :valid-characters-only="true"
        :inputOptions="{ autocomplete: 'off', showDialCode: false }"
        class="phone-input__field"
    />
</template>

<script>
import { VueTelInput } from 'vue-tel-input';

export default {
    name: 'PhoneInput',
    data() {
        return {
            localValue: this.value == null ? '' : this.value,
            isInitialized: false,
        };
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        defaultCountry: {
            type: [String, Number],
            default: 'PT'
        },
        country: {
            type: String,
            default: null
        },
    },
    computed: {
        activeDefaultCountry() {
            return this.country || this.defaultCountry;
        }
    },
    mounted() {
        setTimeout(() => {
            this.isInitialized = true;
        }, 1);
    },
    watch: {
        value(newVal) {
            this.localValue = newVal == null ? '' : newVal;
        },
        localValue(newVal) {
            if (!this.isInitialized) return;
            this.$emit('input', newVal);
        }
    },
    methods: {
        onValidate(phoneObj) {
            this.$emit('validate', phoneObj);
        },
        onCountryChanged(country) {
            const code = country.dialCode;
            const dial = code ? `+${String(code)}` : null;
            this.$emit('country-changed', { ...country, dial });
        }
    },
    components: { VueTelInput }
};
</script>
<style lang="scss">
    @import '~@/assets/scss/_variables.scss';

    //All !important declarations here are required to override the library's own !important rules.
    .phone-input__field {
        border-radius: 4px !important;
        border: 1px solid #DBDFE2 !important;
        background-color: $lighter;
        position: relative;
        padding: 0.153rem 0.15rem;

        input {
            background-color: $lighter;
            border-radius: 4px;
        }

        .dropdown,
        .vti__dropdown {
            background: none;
            position: static;
        }

        .dropdown:focus,
        .dropdown:focus-within,
        .vti__dropdown:focus,
        .vti__dropdown:focus-within,
        &:focus,
        &:focus-within {
            box-shadow: none !important;
            border-radius: 4px;
        }

        .dropdown ul,
        .vti__dropdown-list {
            top: 100%;
            max-height: 200px;
            width: 110%;
            min-width: 100%;
            max-width: 100.4%;
            border-radius: 4px;
        }
        .vti__dropdown-item {
            cursor: pointer;
            padding: 4px 10px !important;
        }
        .vti__dropdown-list.above {
            bottom: auto !important;
        }
        .vti__flag,
        .vti__input,
        .vti__tel-input,
        input {
            background-color: $lighter !important;
            outline: none !important;
            border: 0 none ;
        }
        
    }
</style>



// WEBPACK FOOTER //
// PhoneInput.vue?0e571f3a